import React from 'react';
import PropTypes from 'prop-types';
import InputText from '../../Common/InputText';
import Toggle from '../../Common/Toggle/Toggle';
import ColorChooser from '../../Common/ColorChooser';
import ImageChooser from '../../Common/ImageChooser/ImageChooser';

export default class BrandForm extends React.Component {

    constructor(props, context) {
        super(props, context);

    }

    onTextChange = (e) => {
        this.props.onFormChange(e.target.name, e.target.value);
    }

    onLogoColorChange = (hex) => {
        this.props.onFormChange("backgroundColor", hex);
    }

    onToggleChange = (name, value) => {
        this.props.onFormChange(name, value);
    }

    onSubmit = (e) => {
        e.preventDefault();
        this.props.onSubmit();
        return false;
    }


    render() {
        return (
            <div className="identifier-form">
                <form noValidate className={this.props.isFormValid ? "" : "was-validated"} onSubmit={this.onSubmit}>
                    <InputText name="name" label="Name" placeholder="Name" type="text" value={this.props.brand.name} onChange={this.onTextChange} isRequired={true} errorMessage="Name is required" />
                    <Toggle name="isActive" text="Active" checked={this.props.brand.isActive} onChange={this.onToggleChange} />
                    <ColorChooser title="Logo Background Color" name="backgroundColor" selectedColor={this.props.brand.backgroundColor} onChange={this.onLogoColorChange} />
                    <ImageChooser name="logo" title="Upload Subscription Logo" backgroundColor={this.props.brand.backgroundColor} imageUrl={this.props.brand.logoUrl} onChange={this.props.onLogoChange} />
                </form>
            </div>
        );
    }

}

BrandForm.propTypes = {
    onFormChange: PropTypes.func.isRequired, // returns (field, value)
    isFormValid: PropTypes.bool.isRequired,
    onLogoChange: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
    brand: PropTypes.object
}
